// extracted by mini-css-extract-plugin
export var wordContainer = "_qw-0";